import { useEffect } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw';
import 'leaflet-draw/dist/leaflet.draw.css';
import { googleHybridProvider } from '../../MapWithDrawing/Measure/mapUtils';

// Phoenix default — zoomed-out AZ view
const DEFAULT_CENTER = [33.505, -112.15];
const DEFAULT_ZOOM = 11;

/**
 * Initializes a Leaflet map in the given container ref.
 * Populates parent-owned refs so other hooks can share them.
 */
export default function useMapInit(containerRef, { mapRef, drawnItemsRef, tileLayerRef }) {
  useEffect(() => {
    if (!containerRef.current || mapRef.current) return;

    const map = L.map(containerRef.current, {
      center: DEFAULT_CENTER,
      zoom: DEFAULT_ZOOM,
      maxZoom: 28,
      zoomControl: true,
      preferCanvas: false,
    });

    const tileLayer = L.tileLayer(googleHybridProvider.url, {
      attribution: googleHybridProvider.attribution,
      maxNativeZoom: 20,
      maxZoom: 28,
      errorTileUrl: '',
    }).addTo(map);

    const drawnItems = new L.FeatureGroup();
    map.addLayer(drawnItems);

    mapRef.current = map;
    drawnItemsRef.current = drawnItems;
    tileLayerRef.current = tileLayer;

    setTimeout(() => {
      try { map.invalidateSize(); } catch (_) {}
    }, 100);

    return () => {
      try {
        map.remove();
      } catch (_) {}
      mapRef.current = null;
      drawnItemsRef.current = null;
      tileLayerRef.current = null;
    };
  }, []);
}
